module.exports = __webpack_public_path__ + "img/Approve-tick-mark.63f287dc.svg";